import { Control, useWatch } from 'react-hook-form';

import Button from '@ingka/button';
import { CustomTextField } from '../../../shared/components/CustomTextField';
import React from 'react';
import documentPencilIcon from '@ingka/ssr-icon/paths/document-pencil';
import styled from '@emotion/styled';
import { tokens } from '../../../shared/styles/core/tokens';

interface MaterialGradeIdFieldProps {
    control: Control<any>;
    label: string;
    disabled?: boolean;
    customErrorMessage?: string;
    onChangeClick: () => void;
}

export const MaterialGradeIdField: React.FC<MaterialGradeIdFieldProps> = ({
    control,
    label,
    disabled,
    customErrorMessage,
    onChangeClick,
}) => {
    const currentValue = useWatch({ control, name: 'materialGradeId' });
    const enhancedLabel = currentValue === '0' ? `${label} (Unassigned)` : label;

    return (
        <FieldWrapper>
            <TextFieldWrapper>
                <CustomTextField
                    field="materialGradeId"
                    control={control}
                    label={enhancedLabel}
                    disabled={true}
                    customErrorMessage={customErrorMessage}
                />
            </TextFieldWrapper>
            {!disabled && (
                <Button
                    type="primary"
                    onClick={onChangeClick}
                    ssrIcon={documentPencilIcon}
                    iconOnly={true}
                    small={true}
                    title="Change Material Grade ID"
                />
            )}
        </FieldWrapper>
    );
};

const FieldWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.space.sm};
  width: 100%;
`;

const TextFieldWrapper = styled.div`
  flex: 1;
`;